import { render } from "./GenericDetail.vue?vue&type=template&id=a87e7190"
import script from "./GenericDetail.vue?vue&type=script&lang=js"
export * from "./GenericDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/public_html/wp-content/plugins/woo-portal-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__